// extracted by mini-css-extract-plugin
export var content = "_az-3";
export var list = "_az-4";
export var settingsContent = "_az-7";
export var settingsPanel = "_az-8";
export var state = "_az-6";
export var triggerBadge = "_az-2";
export var triggerButton = "_az-1";
export var triggerShell = "_az-0";
export var unreadDot = "_az-5";